/* global document */
// NOTE: A lot of this code abuses the broken isNaN() global,
// and it's too risky to change to Number.isNaN() because lol tests?
/* eslint-disable no-restricted-globals */
/**
 * js
 * Miscellaneous String and Number formatters
 */

/**
 * &#8202; => hair space entity
 */
var HAIRSPACE = String.fromCharCode(8202);

/**
 * map currency code to symbol
 * TODO: a separate npm package would be preferred to handle localization
 * ticket number: CAN-123
 */
var CURRENCY_SYMBOL_MAP = {
    CAD: 'C$',
    USD: '$'
};

/**
 * Returns the given value as a base10 integer.
 *
 * @deprecated Just use `parseInt(n, 10)`
 * @param {Number|String} n
 * @return {Number} base10 integer
 */
function toInt(n) {
    return parseInt(n, 10);
}

/**
 * Returns an abbreviated string representation of number in form:
 *
 * @example
 * 999999 < abs(num) < Infinity => xxxM
 * 99999 < abs(num) < 999999 => xxxK
 * 0 <= abs(num) < 99999 => num
 *
 * @param {Number|String} num
 * @return {String} the formatted string
 */
function abbr(num) {
    var n = parseInt(num, 10);
    var v = void 0;
    var s = void 0;

    if (isNaN(n)) {
        n = 0;
    }

    var an = Math.abs(n);

    if (an >= 1000000000) {
        v = parseInt(n / 100000000, 10) / 10;
        s = 'B';
    } else if (an >= 1000000) {
        v = parseInt(n / 100000, 10) / 10;
        s = 'M';
    } else if (an >= 1000) {
        v = parseInt(n / 100, 10) / 10;
        s = 'K';
    } else {
        v = parseInt(n, 10);
        s = '';
    }

    //  1000 => 1K
    //  2500 => 2.5K
    // 10000 => 10K
    // 12500 => 12K
    if (v >= 10) {
        v = parseInt(v, 10);
    }

    return v + s;
}

/**
 * Converts a formatted string into a number,
 * including shorthand postfixes "M", "K", etc.
 *
 * @param {String} str Formatted string
 * @return {Number}
 */
function fromString(s) {
    if (!s && s !== 0) {
        return NaN;
    }

    // Coerce to a string
    var str = '' + s;

    // Check to see if the string is negative before stripping
    var negative = str.charAt(0) === '-';

    var strippedStr = /(-?(?:(?:\d|\.)+))\s*([bmkt])?/i.exec(str.replace(/,/g, ''));
    if (!strippedStr) {
        return NaN;
    }

    var numPart = parseFloat(strippedStr[1]);
    if (isNaN(numPart)) {
        return NaN;
    }

    // Convert to negative
    // Note: This may be necessary due to invalid regex. Negatives are
    // correctly parsed when the value doesn't have a dollar sign, so we
    // have to check here to see if it is already negative before swapping
    // the sign.
    if (negative && numPart > 0) {
        numPart *= -1;
    }

    var tPart = strippedStr[2];

    switch (tPart) {
        case 'T':
        case 't':
            return numPart * 1e12;

        case 'B':
        case 'b':
            return numPart * 1e9;

        case 'M':
        case 'm':
            return numPart * 1e6;

        case 'K':
        case 'k':
            return numPart * 1000;

        default:
            return numPart;
    }
}

function formatNumberField(thisField, caretPos, isCurrency) {
    // TODO Y.one replaced by following line. really this shouldn't be in formatters at all
    // but kinda keeping compat by assuming class for now.
    var fieldNode = document.getElementsByClassName(thisField)[0];
    var n = fromString(fieldNode.get('value'));

    if (!isNaN(n)) {
        if (n >= 0) {
            // positive numbers only
            if (isCurrency) {
                fieldNode.set('value', dollar(n));
            } else {
                fieldNode.set('value', comma(n));
            }
            if (caretPos) {
                // pass in dom node
                setCaretPosition(thisField, caretPos);
            }
        }
    }
}

function formatPhoneNumberField(thisField) {
    var fieldNode = document.getElementsByClassName(thisField)[0];
    var n = fieldNode.get('value');

    fieldNode.set('value', phoneNumber(n));
}

/**
 * This will do a simple task to add white space between
 * Canadian zipcodes.
 * @example '98101' => '98101' / 'V5X1M6' => 'V5X 1M6'
 * @param {String} zipcode
 * @returns {String} formatted Canadian Zipcode
 */
function formatZipcode(zipcode) {
    if (zipcode && zipcode.length === 6) {
        return zipcode.slice(0, 3) + ' ' + zipcode.slice(3);
    }
    return zipcode;
}

function getCaretPosition(thisField, isCurrency) {
    var fieldValue = thisField.value;
    var caretPos = 0;
    var thisSel = void 0;

    // IE Support
    if (document.selection) {
        thisField.focus();
        thisSel = document.selection.createRange();
        thisSel.moveStart('character', -fieldValue.length);
        caretPos = thisSel.text.length;
    } else if (thisField.selectionStart || thisField.selectionStart === 0) {
        // FF support
        caretPos = thisField.selectionStart;
    }

    if (isCurrency && fieldValue.charAt(0) !== '$') {
        caretPos += 1;
    }

    for (var i = 0; i < caretPos; i += 1) {
        if (fieldValue.charAt(i) === ',') {
            caretPos -= 1;
        }
    }

    return caretPos;
}

function setCaretPosition(thisField, caretPos) {
    /* eslint-disable no-param-reassign */
    for (var i = 0; i < caretPos; i += 1) {
        if (thisField.value.charAt(i) === ',') {
            caretPos += 1;
        }
    }

    // IE Support
    if (document.selection) {
        thisField.focus();
        var thisSel = document.selection.createRange();
        thisSel.moveStart('character', -thisField.value.length);
        thisSel.moveStart('character', caretPos);
        var moveEnd = thisField.value.length - caretPos;
        thisSel.moveEnd('character', -moveEnd);
        thisSel.select();
    } else if (thisField.selectionStart || thisField.selectionStart === 0) {
        // FF support
        thisField.selectionStart = caretPos;
        thisField.selectionEnd = caretPos;
        thisField.focus();
    }
    /* eslint-enable no-param-reassign */
}

/**
 * Takes a date and a string in form 'd/m/Y',
 * returns a formatted date string
 *
 * @example
 * d => day (2 digits, leading 0)
 * D => day (2 digits, no leading)
 * l => day (of week, text, 3 chars)
 * L => day (of week, text, full length)
 *
 * m => month (2 digits, leading 0)
 * M => month (2 digits, no leading 0)
 * f => month (text, 3 chars)
 * F => month (text, full length)
 *
 * y => year (2 digits)
 * Y => year (4 digits)
 *
 * g => hour (12hr, leading 0)
 * G => hour (12hr, no leading)
 * i => minute
 * s => second
 * t => hour (12hr, formatted with am/pm)
 *
 * @param {Date} date Date instance to format into string
 * @param {String} format String for the formatting of this Date object
 * @return {String}
 */
function formatDate(date, format) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var fulldays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var fullmonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function twoDigits(n) {
        return (String(n).length === 1 ? '0' : '') + n;
    }

    var matches = date.matches || {
        d: function d() {
            return twoDigits(date.getDate());
        },
        D: function D() {
            return '' + date.getDate();
        },
        l: function l() {
            return days[date.getDay()];
        },
        L: function L() {
            return fulldays[date.getDay()];
        },
        m: function m() {
            return twoDigits(date.getMonth() + 1);
        },
        M: function M() {
            return date.getMonth() + 1;
        },
        f: function f() {
            return months[date.getMonth()];
        },
        F: function F() {
            return fullmonths[date.getMonth()];
        },
        y: function y() {
            return ('' + date.getFullYear()).slice(2, 4);
        },
        Y: function Y() {
            return '' + date.getFullYear();
        },
        g: function g() {
            return twoDigits(date.getHours() % 12);
        },
        G: function G() {
            return '' + date.getHours() % 12;
        },
        i: function i() {
            return twoDigits(date.getMinutes());
        },
        s: function s() {
            return twoDigits(date.getSeconds());
        },
        t: function t() {
            return date.getHours() > 11 ? 'pm' : 'am';
        }
    };

    return format.replace(/[dDlLmMfFyYgGist]/g, function (match) {
        return matches[match]();
    });
}

/**
 * Return this number as a string with comma-separated thousands:
 *
 * @example
 * 1234 => 1,234
 * 12345 => 12,345
 *
 * @param {Number|String} n
 * @return {String}
 */
function comma(num) {
    if (isNaN(num)) {
        return num;
    }

    var regexGrouping = /(\d+)(\d{3})/;

    var parts = ('' + num).split('.');
    var ipart = parts[0];
    var fpart = parts.length > 1 ? '.' + parts[1] : '';

    while (regexGrouping.test(ipart)) {
        ipart = ipart.replace(regexGrouping, '$1,$2');
    }

    return ipart + fpart;
}

/**
 * Return this phone number with separation characters:
 *
 * @example
 * 123 => (123)
 * (123) 456 => (123) 456-
 * (123) 456-78901 => (123) 456-7890 x1
 * 1234567890 => (123) 456-7890
 * 12345678901234 => (123) 456-7890 x1234
 *
 * @param {Number|String} n
 * @return {String}
 */
function phoneNumber(num) {
    var areaCodeRegex = /^(\d{3})$/;
    var firstThreeDigitsRegex = /^(\(\d{3}\) \d{3})(-*)$/;
    var extensionRegex = /^(\(\d{3}\) \d{3}-\d{4})(\d+)$/;
    var extensionWithSpaceRegex = /^(\(\d{3}\) \d{3}-\d{4})(\s+)$/;
    var fullNumberRegex = /^(\d{3})(\d{3})(\d{4})$/;
    var fullNumberWithExtensionRegex = /^(\d{3})(\d{3})(\d{4})(\d+)$/;

    var n = '' + num;

    if (areaCodeRegex.test(n)) {
        n = n.replace(areaCodeRegex, '($1) ');
    } else if (firstThreeDigitsRegex.test(n)) {
        n = n.replace(firstThreeDigitsRegex, '$1-');
    } else if (extensionRegex.test(n)) {
        n = n.replace(extensionRegex, '$1 x$2');
    } else if (extensionWithSpaceRegex.test(n)) {
        n = n.replace(extensionWithSpaceRegex, '$1 x');
    } else if (fullNumberRegex.test(n)) {
        n = n.replace(fullNumberRegex, '($1) $2-$3');
    } else if (fullNumberWithExtensionRegex.test(n)) {
        n = n.replace(fullNumberWithExtensionRegex, '($1) $2-$3 x$4');
    }

    return n;
}

/**
 * Returns n as a fixed-point float string, with a
 * constant number of decimal points:
 *
 * @example
 * 100 => 100.00
 * 100.1 => 100.10
 * 100.123 => 100.12
 *
 * @param {Number} n
 * @param {Number} [nPoints=2]
 * @return {String}
 */
function fixedFloat(n, nPoints) {
    if (isNaN(n)) {
        return n;
    }

    // if you pass zero, sorry, you're getting 2


    return parseFloat(n).toFixed(nPoints || 2);
}

/**
 * Returns a number with no more than
 * a specified number of decimal points:
 *
 * @example
 * 100 => 100
 * 100.1 => 100.1
 * 100.123 => 100.12
 *
 * @param {Number|String} n
 * @param {Number} [nPoints=2]
 * @return {Number}
 */
function roundFloat(num, nPoints) {
    if (isNaN(num)) {
        return num;
    }

    // if you pass zero, sorry, you're getting 2
    var p = nPoints || 2;
    var n = fixedFloat(num, p);
    var pow = Math.pow(p, 10);

    return n * pow / pow;
}

/**
 * Returns a rounded float with percentage suffix
 *
 * @param {Number|String} n
 * @param {Number} [p=2]
 * @return {String}
 */
function roundPercent(n, p) {
    return isNaN(n) ? n : roundFloat(n, p) + HAIRSPACE + '%';
}

/**
 * Returns a fixed float with percentage suffix
 *
 * @param {Number|String} n
 * @param {Number} [p=2]
 * @return {String}
 */
function fixedPercent(n, p) {
    return isNaN(n) ? n : fixedFloat(n, p) + HAIRSPACE + '%';
}

/**
 * Returns a string representation of a dollar figure,
 * with comma-separated thousands
 *
 * @param {Number} n
 * @param {boolean} [showCents] Optional flag for showing cents
 * @return {String}
 */
function dollar(n, showCents) {
    return money(n, '$', showCents);
}

/**
 * Returns a string representation of a currency amount,
 * with comma-separated thousands
 *
 * @param {Number} n
 * @param {String} [currencyType] Optional string for currency type
 * @param {boolean} [showCents] Optional flag for showing cents
 * @return {String}
 */
function money(n, currencyType, showCents) {
    if (isNaN(n)) {
        return n;
    }

    var formatted = void 0;

    var ct = currencyType || '$';
    var currencySymbol = CURRENCY_SYMBOL_MAP[ct] || ct;

    if (showCents) {
        formatted = comma(twoPointFloat(n));
    } else {
        formatted = comma(Math.round(n));
    }

    if (formatted.charAt(0) === '-') {
        return '-' + currencySymbol + formatted.slice(1);
    }

    return '' + currencySymbol + formatted;
}

/**
 * Returns an abbreviated money amount with currency symbol.
 *
 * @param {Number|String} n
 * @param {String} [currencyType] Optional string for currency type
 * @return {String}
 */
function largeMoney(n, currencyType) {
    var ct = currencyType || '$';
    var currencySymbol = CURRENCY_SYMBOL_MAP[ct] || ct;
    return isNaN(n) ? n : '' + currencySymbol + abbr(n);
}

/**
 * Returns a comma-formatted rounded float
 *
 * @param {Number|String} n
 * @return {String}
 */
function roundComma(n) {
    return isNaN(n) ? n : comma(roundFloat(n));
}

/**
 * Returns a comma-formatted fixed float
 *
 * @param {Number|String} n
 * @return {String}
 */
function fixedComma(n) {
    return isNaN(n) ? n : comma(fixedFloat(n));
}

/**
 * Returns a comma-formatted integer
 *
 * @param {Number|String} n
 * @return {String}
 */
function wholeComma(n) {
    return isNaN(n) ? n : comma(parseInt(n, 10));
}

/**
 * Returns a dollar-formatted integer.
 *
 * @param {Number|String} n
 * @return {String}
 */
function roundDollar(n) {
    return isNaN(n) ? n : '$' + HAIRSPACE + comma(parseInt(n, 10));
}

/**
 * Returns a abbreviated number.
 *
 * @param {Number|String} n
 * @return {String}
 * @see abbr
 */
function largeNumber(n) {
    return isNaN(n) ? n : abbr(n);
}

/**
 * Returns a two-point-float.
 *
 * @param {Number|String} n
 * @return {Number}
 */
function twoPointFloat(n) {
    return isNaN(n) ? n : parseFloat(n).toFixed(2);
}

/**
 * Returns an abbreviated dollar amount.
 *
 * @param {Number|String} n
 * @return {String}
 */
function largeDollar(n) {
    return isNaN(n) ? n : '$' + HAIRSPACE + abbr(n);
}

/**
 * Returns the time elapsed since the given timestamp.
 *
 * @param {Number|String} time
 * @return {Number}
 */
function getDaysOn(time) {
    return Math.round((new Date().getTime() - time) / (1000 * 60 * 60 * 24));
}

/**
 * Returns a double or integer from a currency string
 *
 * $1,651.51 -> 1651.51
 *
 * @method currencyToNum
 * @param {String} currency
 * @param {Boolean} [convertToInt] Default value false
 */
function currencyToNum(currency, convertToInt) {
    // Remove all non dot/digits
    var num = Number(currency.replace(/[^0-9.]+/g, ''));

    // Convert to integer if convertToInt is true
    if (convertToInt === true) {
        num = parseInt(num, 10);
    }

    return num;
}

/**
 * Converts a number to a string of years and months.
 * <code>monthsToYears(13); // '1 year, 1 month'</code>
 *
 * @method monthsToYears
 * @static
 * @param months {Number} The number of months.
 * @return {String} Year string
 */
function monthsToYears(months) {
    var years = Math.floor(months / 12);
    var remaining = months % 12;
    var text = [];

    // Years
    if (years === 1) {
        text.push(years, ' year');
    } else if (years > 1) {
        text.push(years, ' years');
    }

    // Separator
    if (years > 0 && remaining > 0) {
        text.push(', ');
    }

    // Months
    if (remaining === 1) {
        text.push(remaining, ' month');
    } else if (remaining > 1 || years === 0) {
        text.push(remaining, ' months');
    }

    return text.join('');
}

/**
 * Converts milliseconds into days, hours, or minutes
 *
 * @method millisecondsToMinutesHoursDays
 * @param ms {Number} The number of milliseconds
 * @return {String} x day/days or y hr/hrs or z min,
 *     depending on which is a positive whole number
 */
function millisecondsToMinutesHoursDays(ms) {
    if (typeof ms !== 'number') {
        return '';
    }

    var minutes = Math.floor(ms / 1000 / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);


    if (days > 0) {
        return days === 1 ? days + ' day' : days + ' days';
    }

    if (hours > 0) {
        return hours === 1 ? hours + ' hr' : hours + ' hrs';
    }

    if (minutes < 1) {
        return 'Less than 1 min';
    }

    return minutes + ' min';
}

export { CURRENCY_SYMBOL_MAP, toInt, abbr, fromString, formatNumberField, formatPhoneNumberField, formatZipcode, getCaretPosition, setCaretPosition, formatDate, comma, phoneNumber, fixedFloat, roundFloat, roundPercent, fixedPercent, dollar, money, largeMoney, roundComma, fixedComma, wholeComma, roundDollar, largeNumber, twoPointFloat, largeDollar, getDaysOn, currencyToNum, monthsToYears, millisecondsToMinutesHoursDays };
